export default __webpack_public_path__ + "static/media/microsoft.c89089d7.svg";